<template>
    <div class="fqs-page">
        <div class="main-content">
            <div class="text-front">
                <div class="page-name"><span class="fqs-header">FAQs</span></div>
                <div class="list-item" v-for="(list, index) in lists" :key="index">
                    <button class="toggle-list" @click="toggleDropdown(index)">
                        <div class="list-item-text">{{ list.content.title }}</div>
                        <div class="toggle-btn" :class="{ expanded: showDropdown[index] }">
                            <img src="/images/PlusOutline.png" alt="plus" class="plus-image" />
                            <div>
                                <img
                                    src="/images/MinusOutline.png"
                                    alt="minus"
                                    class="minus-image"
                                />
                            </div>
                        </div>
                    </button>
                    <div v-show="showDropdown[index]">
                        <div class="item-list" v-html="list.content.description"></div>
                    </div>
                </div>
            </div>
            <div class="img-front"></div>
        </div>
        <div class="questions-wrapper">
            <div class="question-body">
                <div class="question-text">
                    <span class="top-text">Still have questions?</span>
                    <span class="bottom-text"
                        >Can’t find the answer you’re looking for? Please contact us.</span
                    >
                </div>
                <button type="button" class="call-to-action" @click="contactUs">
                    <span class="call-to-text">Get in touch</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'

    export default {
        name: 'FAQs',
        data() {
            return {
                showDropdown: {},
                lists: []
            }
        },
        async created() {
            await this.getQuestion()
        },
        methods: {
            async getQuestion() {
                try {
                    const response = await axios.get('/faqs-response')
                    this.lists = response.data.faqs.sections
                } catch (error) {
                    console.error(error)
                }
            },
            toggleDropdown(index) {
                if (!(index in this.showDropdown)) {
                    this.$set(this.showDropdown, index, false)
                }
                this.showDropdown[index] = !this.showDropdown[index]
            },
            contactUs() {
                window.location.href = '/contact-us'
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../sass/_variables.scss';
    .toggle-btn img {
        display: block;
    }
    .toggle-btn .minus-image {
        display: none;
    }

    .toggle-btn.expanded .minus-image {
        display: block;
    }
    .toggle-btn.expanded .plus-image {
        display: none;
    }
    .toggle-btn {
        display: flex;
    }
    .fqs-page {
        background: #000;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding: 140px 0;
    }
    .main-content {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        width: 100%;
    }
    .text-front {
        display: flex;
        flex-direction: column;
        margin-left: 90px;
        flex: 1;
    }

    .fqs-header {
        color: #dedede;
        font-family: Instrument Sans;
        font-size: 44px;
        font-style: normal;
        font-weight: 500;
        line-height: 110%;
        letter-spacing: -1.76px;
    }

    .page-name {
        margin-bottom: 16px;
    }

    .img-front {
        display: flex;
        flex: 1;
        margin-top: 120px;
        background: url('/images/faqspicture.png') no-repeat;
        min-height: 100vh;
    }

    .list-item {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        padding: 24px 0px;
        gap: 24px;
    }

    .list-item-text {
        color: #dedede;
        text-align: initial;
        font-family: Instrument Sans;
        font-size: 26px;
        font-style: normal;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: -0.52px;
    }

    .toggle-list {
        display: flex;
        align-items: center;
        flex: 1;
        justify-content: space-between;
        background: none;
        border: none;
        cursor: pointer;
    }
    .item-list {
        color: #8b8b8b;
        font-family: Instrument Sans;
        font-size: 20px;
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
        letter-spacing: -0.2px;
        list-style: none;
    }
    .questions-wrapper {
        display: flex;
        padding: 32px;
        margin: 100px 90px;
        flex-direction: column;
        border-radius: 15px;
        background: #121212;
        width: 90%;
    }
    .question-body {
        display: flex;

        justify-content: space-between;
        align-items: center;
    }
    .question-text {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 16px;
    }
    .top-text {
        color: #dedede;
        font-family: Instrument Sans;
        font-size: 26px;
        font-style: normal;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: -0.52px;
    }
    .bottom-text {
        color: #acacac;
        font-family: Instrument Sans;
        font-size: 20px;
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
        letter-spacing: -0.2px;
    }
    .call-to-action {
        display: flex;
        padding: 11px 30px 12px 30px;
        justify-content: center;
        align-items: center;
        border-radius: 100px;
        background: #ba87ff;
        border: none;
    }
    .call-to-text {
        color: #000;
        font-family: Instrument Sans;
        font-size: 18px;
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
    }
    @media only screen and (max-width: 768px) {
        .fqs-page {
            display: flex;
            width: 375px;
            padding: 140px 0px;
            align-items: flex-start;
            gap: 8px;
            width: 100%;
            background: #121212;
        }
        .text-front {
            padding: 0 16px;
        }
        .main-content {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            gap: 32px;
            flex: 1 0 0;
        }
        .list-item {
            align-items: flex-start;
        }
        .list-item-text {
            color: var(--updated-greys-200, #dedede);
            font-family: Instrument Sans;
            font-size: 18px;
            font-style: normal;
            font-weight: 650;
            line-height: 120%;
        }
        .item-list {
            color: #acacac;
            font-family: Instrument Sans;
            font-size: 16px;
            font-style: normal;
            font-weight: 650;
            line-height: 125%;
        }
        .toggle-list {
            gap: 40px;
            width: 100%;
        }
        .main-content {
            flex-direction: column;
            gap: 80px;
        }
        .img-front {
            margin-top: 0;
            background: linear-gradient(
                    0deg,
                    rgba(18, 18, 18, 0.08) 0%,
                    rgba(18, 18, 18, 0.08) 100%
                ),
                url('/images/faqspicture.png'),
                lightgray -126.52px 0px / 178.419% 100% no-repeat;
            box-shadow: 24px 70px 50px -10px #121212 inset, 0px -70px 70px -10px #121212 inset;
            min-width: 100%;
        }
        .text-front {
            margin-left: 0;
            gap: 16px;
        }
        .questions-wrapper {
            margin: 0;
            padding: 0;
            width: auto;
            background: none;
        }
        .question-body {
            gap: 24px;
            flex-direction: column;
            align-items: flex-start;
            padding: 16px;
        }
        .call-to-action {
            background: #cdeb09;
            border: none;
        }
    }
</style>
